"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHIMMER_COUNT = exports.NO_VOUCHER_IMAGE = void 0;
var SHIMMER_COUNT = 2;
exports.SHIMMER_COUNT = SHIMMER_COUNT;
var NO_VOUCHER_IMAGE = 'https://static.stgairasia.com/payments/discount/images/no-voucher.svg';
exports.NO_VOUCHER_IMAGE = NO_VOUCHER_IMAGE;